import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackContextFieldDeleted.meta';

export type UseTrackContextFieldDeletedParams = {
  source: 'manual';
  field_name: string;
};

export const useTrackContextFieldDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackContextFieldDeleted = useCallback(
    (params: UseTrackContextFieldDeletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackContextFieldDeleted };
};
